import { FC } from 'react';
import { Divider } from 'antd';
import { CustomGatewayDataModel, GatewayStatusInformationTranslations } from '../../TabGateway/resources/utils';
import GatewayInformationBlock from './GatewayInformationBlock';
import GatewayStatusBlock from './GatewayStatusBlock';

interface Props {
  gateway: CustomGatewayDataModel;
  informationTranslations: GatewayStatusInformationTranslations;
  onUnassignGateway: () => void;
  onUpdateGateway: (gateway: CustomGatewayDataModel) => void;
  onRebootGateway: () => void;
  hasPermissionToEditGatewayLink: boolean;
  isGatewayLinked: boolean;
  hasPermissionToRebootGateway: boolean;
}

const GatewayStatus: FC<Props> = ({
  gateway,
  informationTranslations,
  onUnassignGateway,
  onUpdateGateway,
  onRebootGateway,
  hasPermissionToEditGatewayLink,
  isGatewayLinked,
  hasPermissionToRebootGateway,
}) => {
  return (
    <>
      <GatewayInformationBlock
        gateway={gateway}
        translations={informationTranslations}
        onUnassignGateway={onUnassignGateway}
        onUpdateGateway={onUpdateGateway}
        onRebootGateway={onRebootGateway}
        hasPermissionToEditGatewayLink={hasPermissionToEditGatewayLink}
        isGatewayLinked={isGatewayLinked}
        hasPermissionToRebootGateway={hasPermissionToRebootGateway}
      />
      <Divider />
      <GatewayStatusBlock
        checkValues={gateway.checkedValues}
        percentValues={gateway.percentValues}
      />
    </>
  );
};

export default GatewayStatus;
